import React from 'react';
import {injectIntl} from 'react-intl';
import {BUDGET_TYPE, BUTTON_COLOR, BUTTON_STYLE, PERIODICITY, PERIOD_BUDGET_TYPE} from '../../../constants';
import Button from '../../../forecast-app/shared/components/buttons/button/button';
import InputFieldV2 from '../input_field';
import DropdownV2 from '../../../forecast-app/shared/components/dropdowns/dropdown';
import Util from '../../../forecast-app/shared/util/util';
import {ComponentContainer, ButtonsStyled, SpecificValuesStyled} from '../../../styles/v2/project/project_budget_type_controls';
import HoursInput from '../../../forecast-app/shared/components/inputs/hours-input/hours_input_view';
import {InputLabel, CurrencyInput} from 'web-components';
import { hasFeatureFlag } from '../../../forecast-app/shared/util/FeatureUtil';

const ProjectBudgetTypeControls = props => {
	const {
		intl,
		budgetType,
		project,
		currency,
		defaultPeriodBudgetType,
		handledefaultPeriodChange,
		defaultPeriodHoursAmount,
		defaultPeriodPriceAmount,
		onPeriodBudgetTypeChange,
		defaultPeriodPeriodicity,
		wrongPeriodLength,
		wrongPeriodAmount,
		errorMessage,
		defaultPeriodLength,
		handlePeriodLengthChange,
		onPeriodicityChange,
		handleFixedPriceBudget,
		fixedPriceBudget,
		rateCardSelected,
		invalidFixedPriceFormat,
		onBudgetTypeChange,
		handleSelectRateChange,
		rate_card_options,
		useRetainers,
	} = props;

	const {formatMessage} = intl;
	const isFixedPriceType = budgetType => {
		return budgetType === BUDGET_TYPE.FIXED_PRICE || budgetType === BUDGET_TYPE.FIXED_PRICE_V2;
	};
	const getDefaultFixedPriceBudget = () => {
		return project && isFixedPriceType(project.budgetType) && project.budget !== undefined ? project.budget : '';
	};
	const onBudgetTypeClick = selectedBudgetType => {
		if (selectedBudgetType !== budgetType) {
			const newStateObject = {
				budgetType: selectedBudgetType,
			};
			if (!isFixedPriceType(selectedBudgetType) && isFixedPriceType(budgetType)) {
				newStateObject.invalidFixedPriceFormat = false;
				newStateObject.fixedPriceBudget = getDefaultFixedPriceBudget();
			}
			if (selectedBudgetType !== BUDGET_TYPE.RETAINER && budgetType === BUDGET_TYPE.RETAINER) {
				newStateObject.defaultPeriodPriceAmount = project ? project.defaultPeriodPriceAmount : null;
				newStateObject.defaultPeriodHoursAmount = project ? project.defaultPeriodHoursAmount : null;
				newStateObject.defaultPeriodBudgetType = project && project.defaultPeriodBudgetType ? project.defaultPeriodBudgetType : PERIOD_BUDGET_TYPE.FIXED_HOURS;
				newStateObject.defaultPeriodLength = project && project.defaultPeriodLength ? project.defaultPeriodLength : 1;
				newStateObject.defaultPeriodPeriodicity = project && project.defaultPeriodPeriodicity ? project.defaultPeriodPeriodicity : PERIODICITY.DAILY;
				newStateObject.wrongPeriodLength = false;
				newStateObject.wrongPeriodAmount = false;
			}
			onBudgetTypeChange(newStateObject);
		}
	};
	const onDefaultPeriodHoursChange = value => {
		handledefaultPeriodChange('defaultPeriodHoursAmount', value);
	};
	const onDefaultPeriodPriceChange = value => {
		handledefaultPeriodChange('defaultPeriodPriceAmount', value);
	};
	const onPeriodLengthChange = value => {
		let newObject;
		if (value === null || value === undefined || value === '' || value < 1) {
			newObject = {defaultPeriodLength: value, wrongPeriodLength: true, errorMessage: formatMessage({id: 'retainer.period_lenght_error'})};
		} else {
			newObject = {wrongPeriodLength: false, defaultPeriodLength: Math.round(value)};
		}
		handlePeriodLengthChange(newObject);
	};
	const getInvalidFixedPriceBudgetErrorMessage = () => {
		return !isNaN(fixedPriceBudget) && fixedPriceBudget <= 0 ? formatMessage({id: 'common.must_be_greater_than_zero'}) : formatMessage({id: 'common.invalid_format'});
	};
	const validateFixedPriceBudget = () => {
		const invalidFixedPriceFormat = !parseFloat(fixedPriceBudget) || fixedPriceBudget <= 0;
		const newValuesObject = {
			invalidFixedPriceFormat,
			errorMessage: invalidFixedPriceFormat ? getInvalidFixedPriceBudgetErrorMessage() : null,
		};
		return newValuesObject;
	};
	const options_billing_period = [
		{value: PERIODICITY.DAILY, label: 'Daily'},
		{value: PERIODICITY.WEEKLY, label: 'Weekly'},
		{value: PERIODICITY.MONTHLY, label: 'Monthly'},
	];
	const options_period_budget_type = [
		{
			value: PERIOD_BUDGET_TYPE.FIXED_HOURS,
			label: Util.getPeriodBudgetTypeTranslation(PERIOD_BUDGET_TYPE.FIXED_HOURS, intl),
		},
		{
			value: PERIOD_BUDGET_TYPE.FIXED_PRICE,
			label: Util.getPeriodBudgetTypeTranslation(PERIOD_BUDGET_TYPE.FIXED_PRICE, intl),
		},
		{
			value: PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS,
			label: Util.getPeriodBudgetTypeTranslation(PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS, intl),
		},
	];
	// Users with no time registration
	const noTimeReg = hasFeatureFlag('no_time_reg');
	const lockFinance = !props.hasFinance;
	return (
		<ComponentContainer>
			<div className="project-budget-type-controls-container">
				<ButtonsStyled>
					<div className={'budget-type-buttons'}>
						<Button
							text={formatMessage({id: 'new_project_modal.budget_type_fixed_price'})}
							buttonStyle={BUTTON_STYLE.FILLED}
							colorTheme={isFixedPriceType(budgetType) ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
							onClick={() => {
								onBudgetTypeClick(props.fixed_price_v2_enabled ? BUDGET_TYPE.FIXED_PRICE_V2 : BUDGET_TYPE.FIXED_PRICE);
							}}
							cy={'budget-type-buttons-' + BUDGET_TYPE.FIXED_PRICE}
							locked={lockFinance}
							isDisabled={lockFinance}
							tooltipProps={lockFinance ? {infoText: formatMessage({id: 'common.requires_financial_module'}), growable: true} : null}
						/>
						{!noTimeReg && (
							<Button
								text={formatMessage({id: 'new_project_modal.budget_type_time_materials'})}
								buttonStyle={BUTTON_STYLE.FILLED}
								colorTheme={budgetType === BUDGET_TYPE.TIME_AND_MATERIALS ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								onClick={() => {
									onBudgetTypeClick(BUDGET_TYPE.TIME_AND_MATERIALS);
								}}
								cy={'budget-type-buttons-' + BUDGET_TYPE.TIME_AND_MATERIALS}
							/>
						)}
						{noTimeReg || props.hasInvoice ? null : (
							<Button
								text={formatMessage({id: 'common.non-billable'})}
								buttonStyle={BUTTON_STYLE.FILLED}
								colorTheme={budgetType === BUDGET_TYPE.NON_BILLABLE ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								onClick={() => {
									onBudgetTypeClick(BUDGET_TYPE.NON_BILLABLE);
								}}
								cy={'budget-type-buttons-' + BUDGET_TYPE.NON_BILLABLE}
								locked={lockFinance}
								isDisabled={lockFinance}
								tooltipProps={lockFinance ? {infoText: formatMessage({id: 'common.requires_financial_module'}), growable: true} : null}
							/>
						)}
						{!noTimeReg && (
							<Button
								text={'Retainer'}
								buttonStyle={BUTTON_STYLE.FILLED}
								colorTheme={budgetType === BUDGET_TYPE.RETAINER ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								onClick={() => {
									onBudgetTypeClick(BUDGET_TYPE.RETAINER);
								}}
								userpilot={'budget-type-buttons-retainer'}
								cy={'budget-type-buttons-' + BUDGET_TYPE.RETAINER}
								locked={lockFinance}
								isDisabled={lockFinance || !useRetainers}
								tooltipProps={lockFinance ? {infoText: formatMessage({id: 'common.requires_financial_module'}), growable: true} : null}
							/>
						)}
					</div>
				</ButtonsStyled>
				<SpecificValuesStyled>
					<div className="budget-type-specific-values">
						<div className={'price-section ' + budgetType.toLowerCase()}>
							{isFixedPriceType(budgetType) ? (
								<div className={'fixed-price'}>
									<InputFieldV2
										id={'fixed-price-value'}
										autoFocus={true}
										type="number"
										value={fixedPriceBudget}
										label={formatMessage({id: 'common.price'})}
										onChange={handleFixedPriceBudget}
										onBlur={validateFixedPriceBudget}
										invalidInput={invalidFixedPriceFormat}
										required={true}
										errorMessage={errorMessage}
										placeholder="0"
										currency={rateCardSelected ? rateCardSelected.currency : currency}
										cy={'fixed-price-input'}
									/>
								</div>
							) : null}
							{!project && budgetType !== BUDGET_TYPE.NON_BILLABLE ? (
								<div className={'rate-card'}>
									<DropdownV2
										customHeight={30}
										options={rate_card_options}
										onChange={handleSelectRateChange}
										value={rateCardSelected ? rateCardSelected.value : null}
										multi={false}
										label={formatMessage({id: 'empty_state_project_rates.select-placeholder'})}
										clearable={true}
										inputName={'role-input'}
										inputCy={'rate-cards-input-select'}
										listDataCy={'rate-card'}
									/>
								</div>
							) : null}
							{budgetType === BUDGET_TYPE.RETAINER ? (
								<div className={'retainer-section'} data-userpilot={'retainer-settings-section'}>
									{project && project.retainerPeriods.edges.length > 0 ? <div className="existing_periods_warning">{formatMessage({id: 'retainer.settings.change_budget_existing_periods'})}</div> : null}
									<div className={'retainer-length-and-value'}>
										<div className={'retainer-container billing-period'}>
											<div className={'dropdown-custom'}>
												<DropdownV2
													customHeight={30}
													key={'billing-period'}
													options={options_billing_period}
													onChange={onPeriodicityChange}
													clearable={false}
													value={defaultPeriodPeriodicity}
													label={formatMessage({id: 'retainer.settings.billing-period'})}
													inputCy={'billing-period-select'}
													listDataCy={'billing-period'}
												/>
											</div>
											<InputFieldV2
												id={'billing-period-amount'}
												type="number"
												onChange={onPeriodLengthChange}
												value={defaultPeriodLength}
												label={formatMessage({id: 'common.every'})}
												required={true}
												invalidInput={wrongPeriodLength}
												errorMessage={wrongPeriodLength ? errorMessage : null}
												placeholder="0"
												step={1}
												suffix={
													defaultPeriodPeriodicity === PERIODICITY.DAILY
														? formatMessage({id: 'common.days'}).toLowerCase()
														: defaultPeriodPeriodicity === PERIODICITY.WEEKLY
														? formatMessage({id: 'common.weeks'}).toLowerCase()
														: formatMessage({id: 'common.months'}).toLowerCase()
												}
												cy={'billing-period-amount-input'}
											/>
										</div>
										<div className={'retainer-container budget-type-period'}>
											<div className={'dropdown-custom'}>
												<DropdownV2
													customHeight={30}
													key={'period-budget-type'}
													options={options_period_budget_type}
													onChange={onPeriodBudgetTypeChange}
													clearable={false}
													value={defaultPeriodBudgetType}
													label={formatMessage({id: 'retainer.settings.set-period-type'})}
													inputCy={'period-budget-type-select'}
													listDataCy={'period-budget-type'}
												/>
											</div>
										</div>
										{defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS ? (
											<div className={'input-container-v2'}>
												<HoursInput
													value={defaultPeriodHoursAmount}
													mutation={onDefaultPeriodHoursChange}
													placeholder={formatMessage({id: 'hours_input.placeholder'})}
													cy={'billing-period-amount-hours-input'}
													label={formatMessage({id: 'retainer.target'})}
													invalidInput={wrongPeriodAmount}
												/>
											</div>
										) : defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_HOURS ? (
											<div className={'input-container-v2'}>
												<HoursInput
													value={defaultPeriodHoursAmount}
													mutation={onDefaultPeriodHoursChange}
													placeholder={formatMessage({id: 'hours_input.placeholder'})}
													cy={'billing-period-amount-hours-input'}
													required={true}
													label={formatMessage({id: 'common.hours'})}
													extension={' *'}
													invalidInput={wrongPeriodAmount}
												/>
											</div>
										) : defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_PRICE ? (
											<div className={'input-container-v2'}>
												<InputLabel
													text={formatMessage({id: 'common.price'})}
													required
													child={
														<CurrencyInput
															id={'period-price'}
															value={defaultPeriodPriceAmount}
															callback={onDefaultPeriodPriceChange}
															placeholder={'0'}
															currencySymbole={currency}
															blurOnEnter={true}
															sendValueOnBlur={true}
															cy={'billing-period-amount-price-input'}
															hasError={wrongPeriodAmount}
														/>
													}
												/>
											</div>
										) : null}
									</div>
								</div>
							) : null}
						</div>
					</div>
				</SpecificValuesStyled>
			</div>
		</ComponentContainer>
	);
};
export default injectIntl(ProjectBudgetTypeControls);
